module.exports = __webpack_public_path__ + "static/media/instagram-2-1.9f41e00c.svg";